export default {
  FORCE_MINIMUM_DASH_SIDEBAR_AT_WIDTH: 1200
};
